import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Search from 'Components/Search'
import Select from 'Components/Select'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import moment from "moment"
import React, { useEffect, useRef, useState } from 'react'


export default React.memo(props => <Search unsave={props.unsave} limit={30} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
    path={'commun'} requete={Constants.donnee.media} module={Constants.module.COMMUN}
    search={props.search || ((props.searchName || 'media_') + (props.name || '') + User.Entite.get().id)}>
    <SearchForm showAsEntity={props.showAsEntity} />
</Search>
)

const SearchForm = React.memo(props => {
    const [search, setSearch] = useState(props.search || {})
    const refObject = useRef(props.search || {})
    const searching = (data, name) => {
        const srh = {
            ...(search || {}),
            [name]: data
        }
        refObject.current = srh
        setSearch(srh)
        props.searching && props.searching(srh)
    }

    const restate = (data) => {
        console.log('Restate', data)
        if (data && ((data.results && data.results.length > 0) || (
            data.response && data.response.objectDeleted
        ))) {
            const o = data.results && data.results[0] || data.response.objectDeleted
            const inDate = refObject.current['|date_creation'] && refObject.current['|date_creation'][0] && refObject.current['|date_creation'][1] &&
                moment(refObject.current['|date_creation'][0] + " 00:00:00").isSameOrBefore(o.date_creation) &&
                moment(refObject.current['|date_creation'][1] + " 23:59:59").isSameOrAfter(o.date_creation);

            const sameType = refObject.current['type_media_id'] && refObject.current['type_media_id'] === o.type_media_id

            console.log(moment(refObject.current['|date_creation'][0] + " 00:00:00").isSameOrBefore(o.date_creation),
                moment(refObject.current['|date_creation'][1] + " 23:59:59").isSameOrAfter(o.date_creation),
                inDate, sameType)
            console.log(inDate && sameType)
            console.log(refObject.current)
            console.log(!refObject.current['type_media_id'])
            console.log(!refObject.current['|date_creation'])
            if (inDate && sameType) {
                props.searching && props.searching(refObject.current)
            } else if (!refObject.current['type_media_id'] && inDate) {
                props.searching && props.searching(refObject.current)
            } else if (!refObject.current['|date_creation'] && sameType) {
                props.searching && props.searching(refObject.current)
            }
        }
    }

    useEffect(() => {
        Data.addCbRestate(Constants.module.COMMUN, Constants.donnee.media, restate);
        return () => Data.resetCbRestate(Constants.module.COMMUN, Constants.donnee.media)
    }, [])

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>
            <DatePicker value={search['|date_creation']}
                range
                title={EurestoI18n.t('commun:Date de création')}
                onChange={searching}
                name={'|date_creation'} />
            <Select title={EurestoI18n.t('crm:Type')} name="type_media_id"
                onChange={searching}
                value={search['type_media_id']}
                options={[ ...(
                    (User.TypeAccess.get(Constants.access.EURESTO)) && [{
                        value: 85,
                        label: 'Version Euresto'
                    }, {
                        value: 80,
                            label: 'Patch Euresto 32.042.0'
                        }, {
                            value: 81,
                            label: 'Patch Euresto 32.042.1'
                        }, {
                        value: 70,
                        label: 'Patch Mobile'
                    }] || []
                ), {
                    value: 99,
                    label: 'Divers'
                }, ...(
                    (props.showAsEntity || !User.TypeAccess.get(Constants.access.EURESTO)) && [{
                        value: 4,
                        label: 'Archive Fiscale'
                    }] || []
                )]} />
        </Grid>
    )
})


// WEBPACK FOOTER //
// ./app/App/Module/Media/Component/Search/index.js